<template>
  <div>
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <div class="main-content">
      <div>
        <buttonItem :buttonList="menuButtonList" @chooseClick="clickEvent"></buttonItem>
      </div>
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        rowKey="id"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>

    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%">
      <div class="noticeDialog">
        <el-form ref="form" :model="formInfo" label-width="100px" :rules="rules">
          <el-form-item label="版本号：" prop="edition">
            <el-input v-model="formInfo.edition" placeholder="请输入版本号"></el-input>
          </el-form-item>
          <el-form-item label="发布日期：" prop="releaseDate">
            <el-date-picker
              v-model="formInfo.releaseDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="类型：" prop="type">
            <el-select v-model="formInfo.type" placeholder="请选择类型" clearable>
              <el-option label="优化迭代" value="优化迭代"></el-option>
              <el-option label="发版通知" value="发版通知"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称：" prop="name">
            <el-input v-model="formInfo.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="内容：" prop="remark">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="formInfo.remark">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAdd(title)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import buttonItem from '../../../components/ButtonItem';

  export default {
    name: 'index',
    mixins: [tableMixins],
    components: {
      buttonItem,
    },
    data() {
      return {
        title: '',
        dialogVisible: false,
        formInfo: {
          edition: null,
          type: null,
          name: null,
          remark: null,
          releaseDate: '',
        },
        load: false,
        tableData: [],
        columnListDefault: [
          {
            type: 'radio',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'id',
            title: 'id',
            visible: true,
          },
          {
            field: 'edition',
            title: '版本号',
            visible: true,
          },
          {
            field: 'releaseDate',
            title: '发布时间',
            visible: true,
          },
          {
            field: 'type',
            title: '类型',
            visible: true,
          },
          {
            field: 'name',
            title: '名称',
            visible: true,
          },
          {
            field: 'remark',
            title: '详情',
            visible: true,
            width: '800px',
          },
          {
            field: 'gmtCreate',
            title: '创建时间',
            visible: true,
            format: 'time',
          },
          {
            field: 'version',
            title: '版本号',
            visible: true,
          },
          {
            field: 'createBy',
            title: '创建人',
            visible: true,
          },
          {
            field: 'gmtModified',
            title: '修改时间',
            visible: true,
            width: '180',
          },
          {
            field: 'lastModifiedBy',
            title: '修改人',
            visible: true,
            width: '180',
          },
        ],
        query: {
          name: null,
          type: null,
        },
        menuButtonList: [],
        rules: {
          edition: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
          releaseDate: [
            { type: 'string', required: true, message: '请选择日期', trigger: 'change' },
          ],
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          type: [{ required: true, message: '请选择类型', trigger: 'change' }],
          remark: [{ required: true, message: '请输入详情', trigger: 'blur' }],
        },
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            prop: 'name',
            name: '名称',
            type: 'input',
            maxlength: 30,
            placeholder: '请输入名称',
          },
          {
            type: 'select',
            prop: 'type',
            name: '类型',
            options: [
              { label: '优化迭代', value: '优化迭代' },
              { label: '发版通知', value: '发版通知' },
            ],
          },
        ];
      },
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        await this.$axios.post('/maindata/bulletin/listBulletinByPage', params).then((res) => {
          this.load = false;
          this.tableData = res.data.data.list;
          if (this.$refs.siruiTable) {
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      clickEvent(type) {
        switch (type) {
          case 'add':
            this.title = '公告新增';
            this.dialogVisible = true;
            this.$refs.form?.clearValidate();
            break;
          case 'edit':
            this.editNotice();
            break;
          case 'delete':
            this.deleteNotice();
            break;
        }
      },
      deleteNotice() {
        let selectData = this.$refs.siruiTable.getRadioRecord();
        if (!selectData) {
          this.$message({ showClose: true, type: 'info', message: '请选择一条数据' });
          return false;
        }
        this.$axios
          .delete('/maindata/bulletin/deleteBulletin', {}, { id: selectData.id })
          .then((res) => {
            if (res.data.code === 0) {
              this.$message({ showClose: true, type: 'success', message: '操作成功' });
            } else {
              this.$message({ showClose: true, type: 'success', message: res.data.msg });
            }
            this.getData();
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'error', message: '操作失败' });
          });
      },
      // 修改
      editNotice() {
        let selectData = this.$refs.siruiTable.getRadioRecord();
        if (!selectData) {
          this.$message({ showClose: true, type: 'info', message: '请选择一条数据' });
          return false;
        }
        this.title = '公告修改';
        this.formInfo = {
          name: selectData.name,
          type: selectData.type,
          remark: selectData.remark,
          id: selectData.id,
          edition: selectData.edition,
          releaseDate: selectData.releaseDate,
        };
        this.dialogVisible = true;
      },
      //确认新增
      confirmAdd(type) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let params = { ...this.formInfo };
            this.dialogVisible = false;
            if (type === '公告新增') {
              this.$axios
                .post('/maindata/bulletin/saveBulletin', params)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.$message({ showClose: true, type: 'success', message: '操作成功' });
                  } else {
                    this.$message({ showClose: true, type: 'success', message: res.data.msg });
                  }
                  this.getData();
                })
                .catch(() => {
                  this.$message({ showClose: true, type: 'error', message: '操作失败' });
                });
            } else {
              this.$axios
                .put('/maindata/bulletin/updateBulletin', {}, params)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.$message({ showClose: true, type: 'success', message: '操作成功' });
                  } else {
                    this.$message({ showClose: true, type: 'success', message: res.data.msg });
                  }
                  this.getData();
                })
                .catch(() => {
                  this.$message({ showClose: true, type: 'error', message: '操作失败' });
                });
            }
            //清除数据
            for (let key in this.formInfo) {
              this.formInfo[key] = null;
            }
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .noticeDialog {
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
</style>
